import React from 'react';
import { classNames } from '@payfit/growth-platform-brand-system-v2';

export const ImageAnimateOnHover = ({ submenuItem }: any) => {
  return (
    <picture
      className={classNames('flex-shrink-0', 'w-48 h-48', 'xl:w-56 xl:h-56')}
    >
      <img
        alt=""
        src={submenuItem.gif?.url}
        className="group-two-hover:block hidden"
        loading="lazy"
      />
      <img
        alt=""
        src={submenuItem.image?.url}
        className="group-two-hover:hidden block"
        loading="lazy"
      />
    </picture>
  );
};
